import React, { useState } from 'react';
import { Pressable } from 'react-native';

import { Icon } from './Icon';
import { TextTag } from './StyledText';
import { TextInput, View } from './Themed';
import Colors from '../constants/Colors';
import useColorScheme from '../hooks/useColorScheme';

type CardConfig = {
  backgroundColor: string;
  titleText: string;
  amount: number;
};

export default function CardConfigurator({
  children,
  initialConfig,
  visible,
}: {
  children: (config: CardConfig) => React.ReactNode;
  initialConfig: CardConfig;
  visible?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const hide = () => setIsOpen(false);

  const [config, setConfig] = useState<CardConfig>(initialConfig);
  const setBgColor = (color: string) => {
    setConfig((c) => ({ ...c, backgroundColor: color }));
  };

  const theme = useColorScheme();
  return (
    <>
      {visible ? (
        <View style={{ marginBottom: 10, position: 'relative' }}>
          <TextTag
            style={{
              textDecorationLine: 'underline',
              opacity: 0.4,
              cursor: 'pointer',
            }}
            onPress={() => setIsOpen(true)}
          >
            Configure
          </TextTag>
          {isOpen ? (
            <View
              style={{
                position: 'absolute',
                shadowOpacity: 1,
                shadowColor: Colors[theme].shadow,
                shadowRadius: 12,
                backgroundColor: 'white',
                borderRadius: 10,
                padding: 10,
                bottom: 20,
                flexDirection: 'row',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <Pressable onPress={hide}>
                <Icon name="close" style={{ width: 15, height: 15 }} />
              </Pressable>
              <BGChanger
                color={Colors.dark.accent}
                change={setBgColor}
                active={config.backgroundColor}
              />
              <BGChanger
                color={Colors.dark.accentSecondary}
                change={setBgColor}
                active={config.backgroundColor}
              />
              <BGChanger
                color={Colors.dark.backgroundSecondary}
                change={setBgColor}
                active={config.backgroundColor}
              />
              <TextInput
                placeholder="$50"
                placeholderTextColor="gray"
                style={{
                  width: 70,
                  borderWidth: 1,
                  borderColor: 'gray',
                  borderRadius: 5,
                  padding: 4,
                }}
                value={config.amount.toString()}
                onChangeText={(text) =>
                  setConfig((c) => ({ ...c, amount: parseInt(text, 10) }))
                }
              />

              <TextInput
                placeholder="Happy Mother's Day"
                placeholderTextColor="gray"
                value={config.titleText}
                onChangeText={(text) =>
                  setConfig((c) => ({ ...c, titleText: text }))
                }
                style={{
                  width: 200,
                  borderWidth: 1,
                  borderColor: 'gray',
                  borderRadius: 5,
                  padding: 4,
                }}
              />
            </View>
          ) : null}
        </View>
      ) : null}
      {children(config)}
    </>
  );
}

const BGChanger = ({
  color,
  change,
  active,
}: {
  color: string;
  active: string;
  change: (c: string) => void;
}) => {
  return (
    <Pressable onPress={() => change(color)}>
      <View
        style={{
          width: 20,
          height: 20,
          borderRadius: 10,
          backgroundColor: color,
          borderWidth: 3,
          borderColor: active === color ? 'black' : 'white',
        }}
      />
    </Pressable>
  );
};
